import { FunctionComponent } from 'react';
import cn from 'classnames';
import styles from './UserBanner.module.css';

const UserBannerSkeleton: FunctionComponent<{ className?: string }> = ({ className }) => {
    return (
        <div className={cn(styles.useBannerWrap, className)}>
            <div className={cn(styles.useBannerTop, 'shimmer-bg')}>
                <div className={cn(styles.useBannerCard)}>
                    <div className={cn(styles.useBannerCardImage, 'shimmer-bg')}></div>
                    <div className={cn(styles.useBannerCardSummary)}>
                        <div className={cn(styles.skeletonName, 'shimmer-bg')}></div>
                        <div className={cn(styles.skeletonHandle, 'shimmer-bg')}></div>
                        <div className={cn(styles.useTags)}>
                            <div className={cn(styles.skeletonTag, 'shimmer-bg')}></div>
                            <div className={cn(styles.skeletonTag, 'shimmer-bg')}></div>
                            <div className={cn(styles.skeletonTag, 'shimmer-bg')}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cn(styles.useBannerBottom)}>
                <div className={cn(styles.useBannerDetailCol, styles.personalInformation)}>
                    <div className={cn(styles.title, 'shimmer-bg', styles.skeletonTitle)}></div>
                    <div className={styles.detail}>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                    </div>
                </div>
                <div className={cn(styles.useBannerDetailCol, styles.accountRewards)}>
                    <div className={cn(styles.title, 'shimmer-bg', styles.skeletonTitle)}></div>
                    <div className={styles.detail}>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                        <div className={cn('shimmer-bg', styles.skeletonText)}></div>
                    </div>
                </div>
                <div className={cn(styles.useBannerDetailCol, styles.accountBio)}>
                    <div className={cn(styles.title, 'shimmer-bg', styles.skeletonTitle)}></div>
                    <div className={styles.detail}>
                        <div className={cn('shimmer-bg', styles.skeletonBio)}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserBannerSkeleton;
